import axios from 'api';
const config = {
  headers: {
    // withCredentials: true
  }
};
export const getWebConfig = async () => {
  return axios.get(`api/elastic/web_config`, config);
};
